/* eslint-disable no-undef */
import { toast } from "react-toastify";
import { Cart, ProductImages } from "../models/DataModels";

const AppUtils = {
  showModal: function (id = "") {
    $(`#${id}`).modal("show");
  },

  hideModal: function (id = "") {
    $(`#${id}`).modal("hide");
  },

  showProcessingDialog: function (message) {
    $("#dlgProcessingMessage").text(message);
    $("#dlgProcessing").modal("show");
  },

  hideProcessingDialog: function () {
    $("#dlgProcessing").modal("hide");
  },

  showToast: function (message = "Error Occurred", type = "error") {
    switch (type) {
      case "error":
        toast.error(message);
        break;

      case "success":
        toast.success(message);
        break;

      case "warning":
        toast.warning(message);
        break;

      default:
        toast.error(message);
        break;
    }
  },

  validateEmail: function (email) {
    return (
      String(email)
        .toLowerCase()
        .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) !== null
    );
  },

  validateMobileNumber: function (mobileNumber) {
    return (
      String(mobileNumber)
        .toLowerCase()
        .match(/^(\+\d{1,3}[- ]?)?\d{10}$/) !== null
    );
  },

  filterBaseUrl: (apiUrl) => {
    const baseRegex = /^https?:\/\/[^\/]+/; // Matches the protocol and domain
    const baseMatch = apiUrl.match(baseRegex);

    if (baseMatch) {
      const baseUrl = baseMatch[0];
      const remainingPath = apiUrl.slice(baseUrl.length);
      return remainingPath;
    } else {
      // Handle cases where there's no base URL match
      console.error("Invalid API URL:", apiUrl);
      return ""; // Or return null, or throw an error, depending on your needs
    }
  },
};

export default AppUtils;
